import {useEffect, useState} from 'react';
import Answer from './Answer';
import FeedbackMessage from './FeedbackMessage';
import Loading from '../../common/Loading';
import {BiSolidError} from 'react-icons/bi';
import {ReactComponent as CheckIcon} from '../../../assets/feedback/check.svg';
import {ReactComponent as ClickIcon} from '../../../assets/feedback/click.svg';
import {ReactComponent as ErrorIcon} from '../../../assets/feedback/error.svg';
import {ReactComponent as QuestionAbnormal} from '../../../assets/feedback/question-abnormal.svg';
import {ReactComponent as QuestionAnalysis} from '../../../assets/feedback/question-analysis.svg';
import {ReactComponent as QuestionDatabase} from '../../../assets/feedback/question-database.svg';
import {ReactComponent as QuestionDefault} from '../../../assets/feedback/question-default.svg';
import {ReactComponent as QuestionDocument} from '../../../assets/feedback/question-document.svg';
import {ReactComponent as QuestionEmail} from '../../../assets/feedback/question-email.svg';
import {ReactComponent as QuestionFaq} from '../../../assets/feedback/question-faq.svg';
import {ReactComponent as QuestionReport} from '../../../assets/feedback/question-report.svg';
import styles from './styles/detail.module.css';

export default function DetailTemplate({ detailResponse, detailErrorResponse, detailLoading, updateResponse, updateErrorResponse, updateLoading, handleUpdateComment }) {
    const [buttonType, setButtonType] = useState(null);
    const [comments, setComments] = useState({
        adminComment: '',
        userComment: '' // 서울시여성가족재단에서는 사용하지 않음
    });

    const getBotIcon = (type) => {
        if (type === 'ABNORMAL') return <QuestionAbnormal />;
        if (type === 'ANALYSIS') return <QuestionAnalysis />;
        if (type === 'DATABASE') return <QuestionDatabase />;
        if (type === 'DOCUMENT') return <QuestionDocument />;
        if (type === 'EMAIL') return <QuestionEmail />;
        if (type === 'FAQ') return <QuestionFaq />;
        if (type === 'REPORT') return <QuestionReport />;
        
        return <QuestionDefault />;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setComments({
            ...comments,
            [name]: value,
        });
    };

    const handleComment = (type) => {
        setButtonType(type);
        handleUpdateComment({
            id: detailResponse.id,
            type,
            adminComment: comments.adminComment,
            userComment: comments.userComment
        });
    };

    const validateBtn = (type) => {
        if (type === 'NEW' || type === 'PROGRESS') {
            return !!comments.adminComment;
        } else {
            const adminCommentDetail = detailResponse.adminComment === null ? '' : detailResponse.adminComment;
            return adminCommentDetail !== comments.adminComment || detailResponse.userComment !== comments.userComment;
        }
    };

    useEffect(() => {
        if (detailResponse) {
            setComments({
                adminComment: detailResponse.adminComment ?? '',
                userComment: detailResponse.userComment ?? ''
            })
        }
    }, [detailResponse]);

    return (
        <div className={styles.wrapper}>
            {!detailResponse && !detailErrorResponse && !detailLoading &&
                <FeedbackMessage icon={<ClickIcon/>}
                                 message='피드백 선택 필요'
                                 subMessage='피드백을 선택하고 작업을 진행해 주세요.'
                />
            }
            {detailLoading &&
                <FeedbackMessage icon={<Loading/>}
                                 message=''
                                 subMessage=''
                />
            }
            {!detailLoading && detailResponse &&
                <div className={styles.containerTemplate}>
                    <div>
                        <p className={styles.title}>피드백 내용</p>
                        <div className={styles.boxDiv} datatype={detailResponse.optionList.length === 0 && 'none'}>
                            {detailResponse.optionList.length > 0
                                ? detailResponse.optionList.map((option, index) => (
                                    <div className={styles.boxOption} key={index}>
                                        <CheckIcon/>
                                        {option}
                                    </div>
                                ))
                                : '객관식 피드백 없음'
                            }
                        </div>
                        <div className={`${styles.boxDiv} ${styles.boxDiv02}`} datatype={!detailResponse.text && 'none'}>{detailResponse.text || '주관식 피드백 없음'}</div>
                    </div>
                    <div>
                        <p className={styles.title}>질문 및 답변</p>
                        <div className={styles.boxQuestion}>
                            {getBotIcon(detailResponse.type)}
                            <div>{detailResponse.question || '질문 없음'}</div>
                        </div>
                        <Answer answerList={detailResponse.answerList} type={detailResponse.type} />
                    </div>
                    <div>
                        <p className={styles.title}>관리자용 코멘트</p>
                        <input className={styles.inputComment}
                               name='adminComment'
                               value={comments.adminComment}
                               onChange={handleChange}
                               autoComplete='off'
                        />
                    </div>
                    <div className={updateResponse || updateErrorResponse ? `${styles.containerBtn} ${styles.containerBtn02}` : `${styles.containerBtn}`}>
                        {!updateLoading && updateResponse && buttonType === 'SAVE' &&
                            <div className={styles.boxAlert}>
                                <CheckIcon/>
                                관리자용 코멘트가 저장되었습니다.
                            </div>
                        }
                        {!updateLoading && updateErrorResponse && buttonType === 'SAVE' &&
                            <div className={styles.boxAlert}>
                                <BiSolidError style={{ color: 'red' }}/>
                                코멘트 저장 중 오류가 발생했습니다.
                            </div>
                        }
                        <div className={styles.boxBtn}>
                            <button
                                className={validateBtn(detailResponse.state) ? `${styles.btnInactive} ${styles.btnActive}` : `${styles.btnInactive}`}
                                onClick={validateBtn(detailResponse.state) ? () => handleComment('SAVE') : null}
                            >
                                {detailResponse.state === 'NEW' || detailResponse.state === 'PROGRESS' ? '저장하기' : '수정하기'}
                            </button>
                        </div>
                    </div>
                </div>
            }
            {!detailLoading && detailErrorResponse &&
                <FeedbackMessage icon={<ErrorIcon/>}
                                 message={<p style={{margin: 0, marginBottom: '8px', fontSize: '16px'}}>페이지를 불러오는 중 <span style={{color: 'red'}}>오류</span> 발생</p>}
                                 subMessage='잠시 후 다시 시도해 주세요.'
                />
            }
        </div>
    );
}
